export const PERISCOPE_ENTITY_RELATED_OBJECT_TYPES = {
	LOOKUP: 'Lookup',
	REFERENCED_BY: 'ReferencedBy'
};
